import { cn } from "@/lib/utils";

/**
 * Eksplicitan indikator sloja pokrivenosti (A/B/C) iz `coverage_tier`
 * odgovora — dosad je postojao u payloadu ali se nigdje nije prikazivao.
 * A = plan + auto-zona (PGŽ); B = plan u bazi bez auto-zone (treba zonu);
 * C = plan nije u bazi (upload). `null`/undefined → ništa (graceful).
 */
const META = {
  A: {
    label: "Pokrivenost A",
    cls: "border-green-300 bg-green-50 text-green-700",
    hint: "Plan u bazi i zona automatski očitana (PGŽ) — verdikt s citatima članaka.",
  },
  B: {
    label: "Pokrivenost B · treba zonu",
    cls: "border-amber-300 bg-amber-50 text-amber-800",
    hint: "Plan je u bazi, ali zona nije automatski očitljiva (izvan PGŽ vektora) — upiši zonu ili priloži lokacijsku informaciju.",
  },
  C: {
    label: "Pokrivenost C · plan nije u bazi",
    cls: "border-amber-300 bg-amber-50 text-amber-800",
    hint: "Plan ove općine nije u bazi — priloži prostorni plan da dobiješ verdikt s citatima.",
  },
} as const;

export function CoverageBadge({ tier }: { tier?: "A" | "B" | "C" | null }) {
  if (!tier) return null;
  const m = META[tier];
  return (
    <span
      title={m.hint}
      className={cn(
        "inline-flex cursor-help items-center gap-1 rounded-full border px-2 py-0.5 text-[0.72rem] font-medium",
        m.cls,
      )}
    >
      {m.label}
    </span>
  );
}
